import React from "react";

import DirectusCombobox from "./combobox";
import FilterWrapper from "components/filter/wrapper";
import client from "directus/src/client";


export default function CompanyCombobox({  filter, ...props }) {
  return (
    <FilterWrapper label="Company">
      <DirectusCombobox
        client={client}
        collection="companies"
        fields={["id", "name"]}
        searchKeys={["name"]}
        filter={filter}
        {...props}
      />
    </FilterWrapper>
  );
}
